module.exports = __webpack_public_path__ + "img/banner.d3224627.jpg";